import { defineMessages } from 'react-intl';

const messages = defineMessages({
  catg1_text: {
    id: 'we9PeW',
    defaultMessage: 'Additional profit due to online sales increase',
  },
  slider4_txt: {
    id: 'n9xcgs',
    defaultMessage: 'Average shipping costs (%)',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  slider4_tooltip: {
    id: 'XZF9Ji',
    defaultMessage: 'The average amount that is spent on shipping.',
  },
  dropdown_label: {
    id: 'fSAINK',
    defaultMessage: 'Select your best match',
  },
  dropdown_text: {
    id: 'r2hZLs',
    defaultMessage: 'Which industry best describes your business? ',
  },
  row5_input_field_label2: {
    id: 'K9TgxR',
    defaultMessage: 'Percentage Reduction in Shipping Cost',
  },
  row3_input_field_label2: {
    id: 'm/bvKO',
    defaultMessage: 'Online Sale Percentage',
  },
  step2_bold_txt: {
    id: 'feHXPu',
    defaultMessage: 'Step 2: Review Industry Averages',
  },
  row3_input_field_label3: {
    id: 'HWrviw',
    defaultMessage: 'Percentage Reduction in Return',
  },
  row5_input_field_label1: {
    id: 'y5J0kO',
    defaultMessage: 'Calculated Avg Shipping Cost',
  },
  row3_input_field_label1: {
    id: '3bgCg+',
    defaultMessage: 'Estimated Annual Sale',
  },
  dt_row1_text: {
    id: 'qu1zBJ',
    defaultMessage: '% Increase in online sales',
  },
  row1_input_field_label1: {
    id: 'rmIjR3',
    defaultMessage: 'Total Online Sale',
  },
  slider2_tooltip: {
    id: 'qwDJSF',
    defaultMessage:
      'The profit margin after you pay direct business costs, such as labor and materials.',
  },
  pdf_title: {
    id: '62MPkb',
    defaultMessage: 'Sterling BVA ROI Estimator',
  },
  step2_info_txt: {
    id: 'gtdjxo',
    defaultMessage:
      'We provided industry averages for gross profit margin, markdown and shipping costs. Override them if your are different.',
  },
  disclaimer_text: {
    id: '4TpSHv',
    defaultMessage:
      'The results shown are based on certain assumptions including reduction in out of stock, returns, markdowns, shipping costs, and increase in online sales. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider Sterling Intelligent Promising as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage and configurations and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual ROI & benefit will vary depending on individual client configurations and conditions.',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  step3_bold_txt: {
    id: 'i5yJsx',
    defaultMessage: 'Step 3: Get Estimate',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  slider2_txt: {
    id: 'RFFsWM',
    defaultMessage: 'Industry average gross profit margin (%)',
  },
  inputField_txt: {
    id: 'TbU8CW',
    defaultMessage: 'Estimated annual sales',
  },
  dt_row5_text: {
    id: 'iwNAje',
    defaultMessage: '% Reduction in shipping costs due to optimization',
  },
  switch_tooltip: {
    id: '2gkif6',
    defaultMessage: 'Select the factors to use to calculate the benefits.',
  },
  benefit: {
    id: '45ZkgK',
    defaultMessage: 'Benefit',
  },
  dt_row2_text: {
    id: 'wFRP3Z',
    defaultMessage: '% Reduction in out of stock',
  },
  row1_input_field_label2: {
    id: 'BuYi86',
    defaultMessage: 'Industry Avg Profit',
  },
  increase_sale_text: {
    id: 'pYYJEN',
    defaultMessage: 'Increase in sales',
  },
  additional_profit: {
    id: 'XWsyVW',
    defaultMessage: 'Additional profit',
  },
  dropdown_tooltip: {
    id: 'UV9t6o',
    defaultMessage: 'Select your industry for more accurate insights. ',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  slider3_txt: {
    id: '77JYHj',
    defaultMessage: 'Average markdown costs (%)',
  },
  inputField_tooltip: {
    id: 'sFVkCV',
    defaultMessage: 'The estimated amount of sales on an annual basis.',
  },
  catg3_text: {
    id: 'ZAtP+l',
    defaultMessage: 'Returns reduction',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  switch_label: {
    id: 'icenSV',
    defaultMessage: 'Annual benefit factors',
  },
  step1_info_txt: {
    id: 'w4g0W2',
    defaultMessage:
      'Provide details related to your industry, annual sales and what % online into the estimator.',
  },
  catg4_text: {
    id: 'qrP+VX',
    defaultMessage: 'Markdown cost reduction',
  },
  return_est_text: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  step4_info_txt: {
    id: 'c5jJZn',
    defaultMessage:
      'You can choose to connect with our team for a further no-obligation discussion around your business objectives, and where we can help.',
  },
  availableIn: {
    id: 'EPIw8h',
    defaultMessage: 'The MAS ROI is available in',
  },
  dt_row3_text: {
    id: 'rvivWX',
    defaultMessage: '% Reduction in returns',
  },
  switch3_txt: {
    id: 'AxMhQr',
    defaultMessage: 'High',
  },
  slider3_tooltip: {
    id: 'NCav9H',
    defaultMessage: 'The decrease in price due to sales and discounts.',
  },
  switch2_txt: {
    id: 'ovJ26C',
    defaultMessage: 'Medium',
  },
  row4_input_field_label1: {
    id: 'TH8stL',
    defaultMessage: 'Calculated Avg Markdown Cost',
  },
  step1_bold_txt: {
    id: 'McKsZw',
    defaultMessage:
      'Step 1: Enter data in benefit estimator (no contact details required)',
  },
  row4_input_field_label2: {
    id: 'fYTxcS',
    defaultMessage: 'Percentage Reduction in Markdown Costs',
  },
  row2_input_field_label1: {
    id: 'YsulMc',
    defaultMessage: 'Total Store Sale',
  },
  industry_label: {
    id: 'TqlgrX',
    defaultMessage: 'Industry',
  },
  slider1_tooltip: {
    id: 'GtfvGE',
    defaultMessage: 'The percentage of sales for online and digital channels.',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  stepIntroText: {
    id: 'MCmECm',
    defaultMessage: 'Step to use Estimator',
  },
  dt_row4_text: {
    id: 'Gh9zuS',
    defaultMessage: '% Reduction in markdown costs',
  },
  step4_bold_txt: {
    id: 'Me/UUC',
    defaultMessage: ' Step 4: Connect with our team (optional)',
  },
  estimatedTotal: {
    id: 'I3X+Bi',
    defaultMessage: 'Total Estimated Benefits',
  },
  slider1_txt: {
    id: 'mY+Cnq',
    defaultMessage: 'Percent of online and digital sales (%)',
  },
  heading: {
    id: '2Gn4Be',
    defaultMessage: 'See your potential benefits',
  },
  catg5_text: {
    id: '9WyLl3',
    defaultMessage: 'Shipping cost reduction',
  },
  catg2_text: {
    id: 'Zu+saM',
    defaultMessage:
      'Additional profit due to increase in store sales/out of stock reduction',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  reduction_cost_text: {
    id: 'TtQXpT',
    defaultMessage: 'Reduction in costs',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  switch1_txt: {
    id: '477I0g',
    defaultMessage: 'Low',
  },
  catg2_text_short: {
    id: 'wn3tJr',
    defaultMessage: 'Additional profit due to increase in store sales',
  },
  sub_heading: {
    id: 'BL76/d',
    defaultMessage:
      'See how IBM Sterling Intelligent Promising provides increased sales, additional profits, and cost reductions across your enterprise. Select your industry and use the sliders to view the profit and cost benefits. ',
  },
  requestBtn: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  step3_info_txt: {
    id: 'kJPCz+',
    defaultMessage:
      'Generate estimated benefits of using Sterling Intelligent Promising Premium Edition.',
  },
  category: {
    id: 'ccXLVi',
    defaultMessage: 'Category',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
});

export default messages;
